import axios from "axios";
import LocalData from "./LocalData";
import { data } from "react-router";


// Get logged-in user info safely
let info = LocalData.getLoggedInfo();
info = info ? JSON.parse(info) : null;

const path = "urduustaaddemo"
export { path }

let rest_id = info?.restaurant_info?.restaurant_id || null;
let api_id = info?.restaurant_info?.api_id || null;
let user_id = info?.user_info?.id || null;

// test URL
// const API_URL = "https://urduustaadtest.inspiresoftware.co.in/api/v1";
// const ioLink = "https://urduustaadtest.inspiresoftware.co.in/";

// const API_URL = "http://localhost:7009/api/v1"

// live url
const API_URL = "/api/v1";
const IO_URL = "/";

let token = info?.token;
console.log(token);

// Default headers
let headers = {
    Api_Id: api_id || "",
};

// Function to set user info dynamically
const setLoggedUser = (user) => {
    token = user.token
};


const ApiService = {
    Signin: (data) => {
        return axios.post(`${API_URL}/admin/login`, data, {
            headers: { ...headers },
        });
    },

    CreateUser: (data) => {
        return axios.post(`${API_URL}/admin/create`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },
    getAllAdminUsers: () => {
        return axios.get(`${API_URL}/admin/getAdminProfile`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },

    Shayar: () => {
        return axios.get(`${API_URL}/getAll-shayar-admin`, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    AddShayar: (data) => {
        return axios.post(`${API_URL}/create-shayar`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    ToggleShayar: (id) => {
        const info = LocalData.getLoggedInfo();
        const parsedInfo = info ? JSON.parse(info) : null;
        const token = parsedInfo?.token;

        return axios.put(
            `${API_URL}/toggle-publish/${id}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    },


    UpdateShayar: (id, data) => {
        return axios.put(`${API_URL}/shayar/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    DeleteShayar: (id) => {
        return axios.delete(`${API_URL}/delete-shayar/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
    },

    RandomSher: () => {
        return axios.get(`${API_URL}/poetry/random`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    Shayari: () => {
        return axios.get(`${API_URL}/poetry/all`, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    ToggleShayari: (no) => {
        const info = LocalData.getLoggedInfo();
        const parsedInfo = info ? JSON.parse(info) : null;
        const token = parsedInfo?.token;

        return axios.put(
            `${API_URL}/poetry/toggle/${no}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    },


    AddShayari: (data) => {
        return axios.post(`${API_URL}/poetry/new-poetry`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    UpdateShayari: (id, data) => {
        return axios.put(`${API_URL}/poetry/update-poetry/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    DeleteShayari: (poet_id) => {
        return axios.delete(`${API_URL}/poetry/delete-by-poet-id/${poet_id}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    ImportShayari: (data, config) => {
        return axios.post(`${API_URL}/poetry/import`, data, {
            ...config,
            headers: {
                ...config?.headers,
                'Authorization': `Bearer ${token}`,
            },
        });
    },

    GetAllLesson: () => {
        return axios.get(`${API_URL}/lessons/getAll`, {
            headers: { 'Authorization': `Bearer ${token}`, }
        })
    },

    LessonContent: (data) => {
        return axios.post(`${API_URL}/lessons/get-allContent`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    },

    ImportLesson: (formData, config) => {
        return axios.post(`${API_URL}/lessons/import`, formData, {
            ...config,
            headers: {
                ...config?.headers,
                'Authorization': `Bearer ${token}`,
            },
        });
    },

    PublishStatus: (data, id) => {
        return axios.put(`${API_URL}/lessons/publish/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    Dashboard: () => {
        return axios.get(`${API_URL}/admin/dashboard`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    GetVocabulary: () => {
        return axios.get(`${API_URL}/vocabulary/getAllVocabularyNew2`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    UpdateVocabulary: (data, id) => {
        return axios.put(`${API_URL}/vocabulary/update-vocabulary/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    AddVocabulary: (data) => {
        return axios.post(`${API_URL}/vocabulary/new-vocabulary`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    DeleteVocabulary: (id) => {
        return axios.delete(`${API_URL}/vocabulary/delete-by-no/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },
    GetVocabularyCategory: () => {
        return axios.get(`${API_URL}/getAll-vocabularyCategory`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    AddVocabularyCategory: (data) => {
        return axios.post(`${API_URL}/create-vocabularyCategory`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    VocabularyCategoryToggle: (id, data) => {
        return axios.put(`${API_URL}/togglePublishVocabularyCategory/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    UpdateVocabularyCategory: (id, data) => {
        return axios.put(`${API_URL}/vocabularyCategory/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    DeleteVocabularyCategory: (id) => {
        return axios.delete(`${API_URL}/delete-vocabularyCategory/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    ImportVocabulary: (data, config) => {
        return axios.post(`${API_URL}/vocabulary/import/excel`, data, {
            ...config,
            headers: {
                ...config?.headers,
                'Authorization': `Bearer ${token}`,
            },
        });
    },

    PushNotification: (data) => {
        return axios.post(`${API_URL}/manualPushNotification`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    GetNotification: () => {
        return axios.get(`${API_URL}/manualPushNotification/logs`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },
    UpdateLesson: (model_name, data) => {
        return axios.put(`${API_URL}/lessons/updateLesson/${model_name}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
    },

    GetAllUser: () => {
        return axios.get(`${API_URL}/admin/users`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    GetAllUserChats: () => {
        return axios.get(`${API_URL}/aichat/all`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    GetSettings: () => {
        return axios.get(`${API_URL}/settings`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    ToggleIos: (data) => {
        return axios.patch(`${API_URL}/settings/toggle-ios-ads/`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    ToggleAndroid: (data) => {
        return axios.patch(`${API_URL}/settings/toggle-android-ads/`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    ToggleAiMode: (data) => {
        return axios.patch(`${API_URL}/settings/toggle-ai-mode/`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    UpdateAiDisableReason: (data) => {
        return axios.patch(`${API_URL}/settings/update-ai-disable-reason/`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    UpdateShayariNo: (data) => {
        return axios.put(`${API_URL}/poetry/update-order`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    UpdateVocabularyNo: (data) => {

        return axios.put(`${API_URL}/vocabulary/update-order`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
    },

    GetFestival: () => {
        return axios.get(`${API_URL}/getAll-festival-admin`, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },
    AddFestival: (data) => {
        return axios.post(`${API_URL}/create-festival`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    ToggleFestival: (id) => {
        const info = LocalData.getLoggedInfo();
        const parsedInfo = info ? JSON.parse(info) : null;
        const token = parsedInfo?.token;

        return axios.put(
            `${API_URL}/toggle-festival-publish/${id}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    },


    UpdateFestival: (id, data) => {
        return axios.put(`${API_URL}/festival/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    },

    DeleteFestival: (id) => {
        return axios.delete(`${API_URL}/delete-festival/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
    },

    GetAllFestivalShayari: () => {
        return axios.get(`${API_URL}/getAll-festival-poetry`, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    ToggleFestivalShayari: (no) => {
        const info = LocalData.getLoggedInfo();
        const parsedInfo = info ? JSON.parse(info) : null;
        const token = parsedInfo?.token;

        return axios.put(
            `${API_URL}/toggle-festival-poetry-publish/${no}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    },


    AddFestivalShayari: (data) => {
        return axios.post(`${API_URL}/create-festival-poetry`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        })
    },

    UpdateFestivalShayari: (id, data) => {
        return axios.put(`${API_URL}/update-festival-poetry/${id}`, data, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    DeleteFestivalShayari: (id) => {
        return axios.delete(`${API_URL}/delete-festival-poetry/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` },
        });
    },

    UpdateFestivalShayariNo: (data) => {
        return axios.put(`${API_URL}/update-festival-poetry-order`, data, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
    },

    ImportFestivalShayari: (data, config) => {
        return axios.post(`${API_URL}/upload-festival-poetry-excel`, data, {
            ...config,
            headers: {
                ...config?.headers,
                'Authorization': `Bearer ${token}`,
            },
        });
    },

}

export default ApiService
export { user_id, rest_id, setLoggedUser };